import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../router/Paths";
import { setTourEdit } from "../../reducer/tourEditReducer";
import RoleBasedComponent from "../../components/RoleBasedComponent";

export default function ManageInclusionsSection({ packageData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setTourEdit(packageData._id));
    navigate(Paths.tourManagementPackageInclusion, {
      state: { packageData },
    });
  };

  const inclusions = packageData?.inclusions || [];

  // Split inclusions into two columns
  const mid = Math.ceil(inclusions.length / 2);
  const leftColumn = inclusions.slice(0, mid);
  const rightColumn = inclusions.slice(mid);

  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Inclusions</p>
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>
      {/* content  */}
      <div className="flex flex-col sm:items-end gap-6">
        {/* ✅ Inclusions Mapped into Two Columns */}
        <div className="w-full max-w-[836px]">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-1 sm:gap-4 text-sm text-gray-600">
            <div className="space-y-1">
              {leftColumn.map((item: string, index: number) => (
                <p key={index}>{item}</p>
              ))}
            </div>
            <div className="space-y-1">
              {rightColumn.map((item: string, index: number) => (
                <p key={index}>{item}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
